import { siteInfo } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-10 md:mb-14">
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => handleNavClick(e, '#hero')}
              className="inline-flex items-center gap-2 text-xl font-bold font-heading text-background-50 hover:text-primary-400 transition-colors mb-4 cursor-pointer"
            >
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                蚁
              </span>
              {siteInfo.name}
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed">
              高清免费在线观影平台，即点即播不缓冲。海量电影电视剧每日更新，流畅追剧首选。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a
                href="#hero"
                onClick={(e) => handleNavClick(e, '#hero')}
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
              >
                首页
              </a>
              <a
                href="#carousel"
                onClick={(e) => handleNavClick(e, '#carousel')}
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
              >
                精选专题
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
              >
                热播榜单
              </a>
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
              >
                分类导航
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">常见入口</h4>
            <div className="flex flex-col gap-2.5">
              <a
                href="#comments"
                onClick={(e) => handleNavClick(e, '#comments')}
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
              >
                影迷热评
              </a>
              <a
                href="#features"
                onClick={(e) => handleNavClick(e, '#features')}
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
              >
                平台优势
              </a>
              <a
                href="#faq"
                onClick={(e) => handleNavClick(e, '#faq')}
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
              >
                常见问题
              </a>
              <a
                href="#about"
                onClick={(e) => handleNavClick(e, '#about')}
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
              >
                关于我们
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              感谢所有合作伙伴的支持与信任，更多合作方陆续加入中，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 蚂蚁影视. 仅供学习交流使用，请支持正版。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>蚂蚁影视高清免费在线观看不缓冲</span>
          </div>
        </div>
      </div>
    </footer>
  );
}